import LazyLoad from 'vanilla-lazyload'

import '../styles/main.css'
import appendAround from 'vanilla-append-around'

// Templates
import theme from './templates/theme'
import product from './templates/product'
import cart from './templates/cart'
import wishlist from './templates/wishlist'
import blog from './templates/blog'
import article from './templates/article'

// Components
import modal from './components/modal'
import productBuyBox from './components/productBuyBox'
import productGallery from './components/productGallery'
import quantitySelector from './components/quantitySelector'
import cartActions from './components/cartActions'

//Components
import account from './components/account'

window.eHS = {
  theme,
  modal,
  product,
  productBuyBox,
  productGallery,
  quantitySelector,
  account,
  cartActions,
  wishlist,
  blog,
  article
}

document.addEventListener('DOMContentLoaded', () => {
  /* Init lazyload */
  new LazyLoad({
    elements_selector: '.lazy',
    use_native: true
  })

  // Init general theme elements
  theme.init()
  product.init()
  account.init()
  cart.init()
  wishlist.init()
  blog.init()
  article.init()
  appendAround()

  adjustShgBtn()
})

document.addEventListener('rebuy:cart.change', () => {
  const cartUpdatedEvent = new Event('cartUpdated')
  window.dispatchEvent(cartUpdatedEvent);
});

if (document.getElementById('collectionTemplate') || document.getElementById('searchTemplate')) {
  // Set scroll position in session storage
  window.onscroll = () => {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0

    sessionStorage.scrollPos = scrollTop
  }

  // Return scroll position in session storage
  window.onload = () => {
    window.scrollTo(0, sessionStorage.scrollPos || 0)
  }
}

document.addEventListener('rebuy.ready', () => {
  const rebuyATC = document.querySelectorAll('#rebuy-btn')
  const queryID = localStorage.getItem("queryID");

  if (queryID) {
    rebuyATC.forEach(item => {
      item.addEventListener('click', (event) => {
        event.stopImmediatePropagation()

        let rebuyBtn = event.target

        if (event.target != rebuyATC) {
          rebuyBtn = event.target.closest('#rebuy-btn')
        }

        const productIndex = rebuyBtn.dataset.productIndex
        const variantID = rebuyBtn.dataset.variantId

        var clickData = {
          index: productIndex,
          eventName: 'click',
          queryID: queryID,
          objectIDs: [variantID],
        }

        window.algoliaShopify.saveAndSendTrackingConversion(clickData)
      })
    })
  }
})

const adjustShgBtn = () => {
  const $shgBtn = $('.shg-btn');

  if ($('body').hasClass('cs-body') || !$shgBtn.length) return;

  $shgBtn.attr("style", "background-image: linear-gradient(270deg,var(--tw-gradient-stops)) !important")
}